import axios from "axios";
import { apiUrl } from "../../App";

export async function updateUserProfileUseCase(id: string, variables: any) {
  return await axios.patch(`${ apiUrl }/admin/users/${ id }/profile`, variables, {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
    },
  });
}
